module.exports = __webpack_public_path__ + "static/img/Harry-Armstrong.f6692e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harry-Armstrong.jpg
// module id = ZdCS
// module chunks = 0